export enum CourseAttendanceType {
    Registered = 0,
    OneOff = 1,
    Amend = 2,
    Preview = 3
}